// extracted by mini-css-extract-plugin
export default {"DownloadButton":"H2L1L0_9LwszjtAe5Ekz"};